// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"729":"904e7b01","743":"f5e969d4"}[chunkId] + ".chunk.css";
};